import Vue from 'vue';
import Vuex from 'vuex';
import { DpSentryAddBreadcrumb, DpNavigationModule as navigation, DpNotificationModule as notification } from '@docupet/component-library';
import * as city from '@/store/modules/city';
import * as register from '@/store/modules/register';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

// Grab Initial state or create own for env
const initialState = window.__INITIAL_STATE__ || {
  locale: process.env.VUE_APP_LOCALE || 'en_US',
  token: process.env.VUE_APP_TOKEN || null,
  baseUrl: window.BASE_URL || process.env.VUE_APP_BASE_URL,
  cityId: window.CITY || process.env.VUE_APP_CITY_ID,
  citySlug: new URLSearchParams(window.location.search).get('city') || null,
};

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: ({ citySlug, ...persistable }) => persistable, // eslint-disable-line no-unused-vars
});

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    register,
    city,
    navigation,
    notification,
  },
  state: initialState,
  getters: {
    getBaseUrl: ({ baseUrl }) => baseUrl || window.BASE_URL || process.env.VUE_APP_BASE_URL,
    generateFullUrl: ({ baseUrl }) => (path) => `${baseUrl}${path || ''}`,
    getToken: (state) => state.register.token,
    getCityId: (state, getters) => getters['register/getCityID'] || state.cityId || window.CITY,
    getCitySlug: (state) => state.citySlug,
    getCityQuery: (state) => (state.citySlug ? { city: state.citySlug } : {}),
  },
  plugins: [
    vuexLocal.plugin,
    (store) => {
      store.subscribeAction((action, state) =>
        DpSentryAddBreadcrumb('Action', 'info', action?.type || '', {
          ...state,
          token: null,
        })
      );
      store.subscribe((mutation) => DpSentryAddBreadcrumb('Mutation', 'info', mutation?.type || ''));
    },
  ],
});
